import React from 'react';
import { useNavigate } from 'react-router-dom';
import FamilyCommandCenter from './FamilyCommandCenter';
import { Helmet } from 'react-helmet-async';

const FamilyCentral = () => {
    const navigate = useNavigate();

    const handleNavigateToGrocery = () => {
        navigate('/grocery');
    };

    const handleNavigateToHousehold = () => {
        navigate('/household');
    };

    return (
        <React.Fragment>
            <Helmet>
                <title>Dymock Family Central</title>
            </Helmet>
            <FamilyCommandCenter 
                onNavigateToGrocery={handleNavigateToGrocery}
                onNavigateToHousehold={handleNavigateToHousehold}
            />
        </React.Fragment>
    );
};

export default FamilyCentral;
